import { TextField, TextFieldProps } from '@mui/material';
import { Control, Controller } from 'react-hook-form';
import { NumericFormatProps } from 'react-number-format';
import { useErrorMessageResolver } from '../../localization/useErrorMessageResolver';
import { NumericInput } from '../input/NumericInput';

export type FormNumericInputProps = {
  control: Control<any>;
  name: string;
  numericInputProps?: NumericFormatProps;
  readonly?: boolean;
} & Omit<TextFieldProps, 'name'>;
export const FormNumericInput = ({
  control,
  name,
  InputProps,
  numericInputProps,
  readonly,
  defaultValue = '',
  ...textProps
}: FormNumericInputProps) => {
  const resolveErrorMessage = useErrorMessageResolver();
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { ref, value, ...fieldRest }, fieldState: { error } }) => (
        <TextField
          {...textProps}
          {...fieldRest}
          value={value ?? ''}
          inputRef={ref}
          error={!!error}
          helperText={error?.message ? resolveErrorMessage(error.message) : textProps.helperText}
          fullWidth
          variant={readonly ? 'standard' : textProps.variant}
          InputProps={{
            ...InputProps,
            readOnly: readonly ?? InputProps?.readOnly,
            disableUnderline: readonly ?? InputProps?.readOnly,
            inputComponent: NumericInput as any,
            inputProps: {
              ...(numericInputProps as any),
              ...InputProps?.inputProps,
            },
          }}
        />
      )}
    />
  );
};
